import React, { useEffect, useMemo, useState } from "react";
import {
  InputGroup,
  InputLeftElement,
  Input,
  Flex,
  useColorMode,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  Text,
  IconButton,
  Select,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalCloseButton,
  Button,
  FormControl,
  FormLabel,
  useDisclosure,
} from "@chakra-ui/react";
import {
  FaRegEdit,
  FaTrash,
  FaAngleDoubleLeft,
  FaAngleDoubleRight,
} from "react-icons/fa";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import { SearchIcon } from "@chakra-ui/icons";
import {
  useTable,
  useSortBy,
  usePagination,
  useGlobalFilter,
} from "react-table";
import {
  collection,
  getDocs,
  deleteDoc,
  doc,
  updateDoc,
} from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { db } from "api/firebase/firebaseConfig";
import { useRecoilValue } from "recoil";
import { userState } from "states/recoil";

function DashboardSuperAdmin() {
  const { colorMode } = useColorMode();
  const user = useRecoilValue(userState);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [globalFilter, setGlobalFilter] = useState("");
  const [userLoaded, setUserLoaded] = useState(false);

  const { isOpen, onOpen, onClose } = useDisclosure();
  const [editUserData, setEditUserData] = useState(null);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, "users"));
        const users = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setData(users);
      } catch (error) {
        console.error("Failed to fetch users:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchUsers();
  }, []);

  const handleDeleteClick = async (row) => {
    // const { id: docId, email, uid } = row.original || {};
    // const targetEmail = (email || docId || "").toLowerCase();
    // if (!targetEmail) {
    //   alert("Gagal menghapus: email/docId tidak ada.");
    //   return;
    // }
    // if (!window.confirm(`Hapus user ${targetEmail}?`)) return;
    // try {
    //   const auth = getAuth();
    //   const token = await auth.currentUser.getIdToken(true);
    //   const resp = await fetch("/api/deleteUser", {
    //     method: "POST",
    //     headers: {
    //       "Content-Type": "application/json",
    //       Authorization: `Bearer ${token}`,
    //     },
    //     body: JSON.stringify({ email: targetEmail, docId: targetEmail }),
    //   });
    //   // robust parse (prevents "Unexpected end of JSON input")
    //   const ct = resp.headers.get("content-type") || "";
    //   const raw = await resp.text();
    //   const json =
    //     ct.includes("application/json") && raw ? JSON.parse(raw) : {};
    //   if (!resp.ok) throw new Error(json.error || raw || `HTTP ${resp.status}`);
    //   setData((prev) =>
    //     prev.filter((u) => (u.email || "").toLowerCase() !== targetEmail)
    //   );
    //   alert(`User ${targetEmail} deleted (Auth + Firestore).`);
    // } catch (err) {
    //   console.error("Delete failed:", err);
    //   alert(`Delete failed: ${err.message || err}`);
    // }
  };

  const handleEditClick = (row) => {
    setEditUserData(row.original);
    onOpen();
  };

  const handleSave = async () => {
    if (!editUserData || !editUserData.id) return;
    console.log(editUserData);

    try {
      const userDocRef = doc(db, "users", editUserData.email);
      await updateDoc(userDocRef, {
        nik: editUserData.nik,
        email: editUserData.email,
        name: editUserData.name,
        province: editUserData.province,
        level: editUserData.level,
      });

      setData((prev) =>
        prev.map((u) => (u.email === editUserData.email ? editUserData : u))
      );

      onClose();
    } catch (error) {
      console.error("Failed to update user:", error);
    }
  };

  const columns = useMemo(
    () => [
      {
        Header: "Aksi",
        Cell: ({ row }) => (
          <Flex direction="row" justifyContent="space-between" gap={2}>
            {row.original.level !== 999 && (
              <>
                <FaRegEdit
                  color="green"
                  cursor="pointer"
                  onClick={() => handleEditClick(row)}
                />
                <FaTrash
                  color="orange"
                  cursor="pointer"
                  onClick={() => handleDeleteClick(row)}
                />
              </>
            )}
          </Flex>
        ),
      },
      { Header: "NIK", accessor: "nik" },
      { Header: "Email", accessor: "email" },
      { Header: "Nama", accessor: "name" },
      { Header: "Provinsi", accessor: "province" },
      { Header: "Role/Level", accessor: "level" },
    ],
    []
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    setGlobalFilter: setTableGlobalFilter,
    state: { pageIndex, pageSize, globalFilter: tableGlobalFilter },
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    canPreviousPage,
    canNextPage,
    pageCount,
  } = useTable(
    {
      columns,
      data,
      initialState: { pageIndex: 0 },
    },
    useGlobalFilter,
    useSortBy,
    usePagination
  );

  useEffect(() => {
    setTableGlobalFilter(globalFilter);
  }, [globalFilter, setTableGlobalFilter]);

  useEffect(() => {
    if (user && user.name) {
      setUserLoaded(true);
    }
  }, [user]);

  return (
    <>
      <h2>{!userLoaded ? "Memuat..." : `Selamat Datang, ${user.name} `}</h2>
      <Flex my={4} justifyContent="space-between">
        <InputGroup maxW="400px">
          <InputLeftElement
            pointerEvents="none"
            children={<SearchIcon color="gray.300" />}
          />
          <Input
            placeholder="Cari Pengguna / NIK / Provinsi"
            value={globalFilter}
            onChange={(e) => setGlobalFilter(e.target.value)}
            color={colorMode === "light" ? "gray.800" : "gray.100"}
          />
        </InputGroup>
      </Flex>
      <Flex direction="column" w="100%">
        <TableContainer width="100%">
          <Table
            display={loading ? "none" : "inherit"}
            variant="striped"
            colorScheme="gray"
            color={colorMode === "dark" ? "gray.100" : "gray.800"}
            width="100%"
            {...getTableProps()}
          >
            <Thead bg={colorMode === "dark" ? "gray.100" : "gray.800"}>
              {headerGroups.map((headerGroup) => (
                <Tr {...headerGroup.getHeaderGroupProps()}>
                  {headerGroup.headers.map((column) => (
                    <Th
                      {...column.getHeaderProps(column.getSortByToggleProps())}
                      color={colorMode === "dark" ? "gray.800" : "gray.100"}
                      fontSize="16px"
                    >
                      {column.render("Header")}
                      <span>
                        {column.isSorted
                          ? column.isSortedDesc
                            ? " 🔽"
                            : " 🔼"
                          : ""}
                      </span>
                    </Th>
                  ))}
                </Tr>
              ))}
            </Thead>

            <Tbody {...getTableBodyProps()}>
              {page.map((row) => {
                prepareRow(row);
                return (
                  <Tr {...row.getRowProps()}>
                    {row.cells.map((cell) => (
                      <Td
                        {...cell.getCellProps()}
                        color={colorMode === "light" ? "gray.800" : "gray.100"}
                        fontSize="14px"
                      >
                        {cell.render("Cell")}
                      </Td>
                    ))}
                  </Tr>
                );
              })}
            </Tbody>
          </Table>
        </TableContainer>
      </Flex>

      <Flex justifyContent="space-between" alignItems="center" mt={4}>
        <Text color={colorMode === "dark" ? "gray.100" : "gray.800"}>
          Page {pageIndex + 1} of {pageCount}
        </Text>
        <Flex gap={2}>
          <IconButton
            onClick={() => gotoPage(0)}
            disabled={!canPreviousPage}
            icon={<FaAngleDoubleLeft />}
            aria-label="Go to first page"
          />
          <IconButton
            onClick={previousPage}
            disabled={!canPreviousPage}
            icon={<IoIosArrowBack />}
            aria-label="Previous page"
          />
          <IconButton
            onClick={nextPage}
            disabled={!canNextPage}
            icon={<IoIosArrowForward />}
            aria-label="Next page"
          />
          <IconButton
            onClick={() => gotoPage(pageCount - 1)}
            disabled={!canNextPage}
            icon={<FaAngleDoubleRight />}
            aria-label="Go to last page"
          />
        </Flex>
        <Select
          value={pageSize}
          onChange={(e) => setPageSize(Number(e.target.value))}
          width="100px"
          color={colorMode === "dark" ? "gray.100" : "gray.800"}
        >
          {[5, 10, 20, 30, 40, 50].map((size) => (
            <option key={size} value={size}>
              Show {size}
            </option>
          ))}
        </Select>
      </Flex>

      {/* Edit User Modal */}
      <Modal isOpen={isOpen} onClose={onClose} size="xl">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Edit User Data</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            {editUserData && (
              <>
                <FormControl mb={3}>
                  <FormLabel>NIK</FormLabel>
                  <Input
                    value={editUserData.nik || ""}
                    onChange={(e) =>
                      setEditUserData((prev) => ({
                        ...prev,
                        nik: e.target.value,
                      }))
                    }
                  />
                </FormControl>
                <FormControl mb={3}>
                  <FormLabel>Email</FormLabel>
                  <Input
                    value={editUserData.email || ""}
                    onChange={(e) =>
                      setEditUserData((prev) => ({
                        ...prev,
                        email: e.target.value,
                      }))
                    }
                  />
                </FormControl>
                <FormControl mb={3}>
                  <FormLabel>Nama Lengkap (Tanpa Gelar)</FormLabel>
                  <Input
                    value={editUserData.name || ""}
                    onChange={(e) =>
                      setEditUserData((prev) => ({
                        ...prev,
                        name: e.target.value.toUpperCase(),
                      }))
                    }
                  />
                </FormControl>
                <FormControl mb={3}>
                  <FormLabel>Provinsi</FormLabel>
                  <Select
                    color={colorMode === "dark" ? "gray.100" : "gray.800"}
                    id="province"
                    name="province"
                    value={editUserData.province || ""}
                    onChange={(e) =>
                      setEditUserData((prev) => ({
                        ...prev,
                        province: e.target.value,
                      }))
                    }
                  >
                    <option value="">Pilih Provinsi Anda</option>
                    <option value="papua">Papua</option>
                    <option value="papua-barat">Papua Barat</option>
                    <option value="papua-barat-daya">Papua Barat Daya</option>
                    <option value="papua-tengah">Papua Tengah</option>
                    <option value="papua-selatan">Papua Selatan</option>
                    <option value="papua-pegunungan">Papua Pegunungan</option>
                  </Select>
                </FormControl>

                <FormControl mb={3}>
                  <FormLabel>Role/Level</FormLabel>
                  <Select
                    color={colorMode === "dark" ? "gray.100" : "gray.800"}
                    id="level"
                    name="level"
                    value={editUserData.level || ""}
                    onChange={(e) => {
                      setEditUserData((prev) => ({
                        ...prev,
                        level: e.target.value,
                      }));
                    }}
                  >
                    <option value="">Pilih Role/Level</option>
                    <option value="unauthorized">Unauthorized</option>
                    <option value="anggota">Anggota</option>
                    <option value="sekretariat">Sekretariat</option>
                    <option value="administrator">Administrator</option>
                  </Select>
                </FormControl>
              </>
            )}
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="blue" mr={3} onClick={handleSave}>
              Save
            </Button>
            <Button onClick={onClose}>Cancel</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}

export default DashboardSuperAdmin;
